import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAsterisk} from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from "react-i18next";

export default function ChangePasswordButton({onClick, className}) {
    const { t } = useTranslation();
    return (
        <button
            className={`${className} flex flex-row items-center font-inter rounded-xl bg-playmove-lightblue w-40 py-3.5 hover:bg-playmove-yellow`}
            onClick={onClick}><span className="m-auto flex flex-row items-center gap-x-1"><FontAwesomeIcon className="text-playmove-mediumblue" icon={faAsterisk}/> <span className="text-sm text-playmove-gray ">{t("changePasswordButton")}</span></span></button>
    )
}